import AnalysisPopup from '../components/AnalysisPopup';
import BugReportForm from '../components/BugReportForm';
import Sidebar from '../components/Sidebar/Sidebar';
import CanvasContainer from '../components/Canvas/components/common/CanvasContainer';
import Canvas from '../components/Canvas/Canvas';
import { useAnalysis } from '../hooks/useAnalysis';
import { useTour } from '@reactour/tour';
// import { useEffect } from 'react';
import NotesModal from '../components/NotesModal/NotesModal';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export const Analysis = () => {
  const {
    isResultLoading,
    resultData,
    imageData,
    isImageLoading,
    isPopupOpen,
    setIsPopupOpen,
    setIsNotesModalOpen,
    isNotesModalOpen,
    canvasProps,
    selectedMrzId,
    sidebarProps,
  } = useAnalysis();

  const { isOpen, currentStep, setCurrentStep } = useTour();

  useEffect(() => {
    if (isOpen) {
      if (
        currentStep === 5 &&
        selectedMrzId === '91a59c69-d03c-4f81-87ee-1be380149a0a'
      ) {
        setCurrentStep(6);
      }
      if (currentStep === 7 && !selectedMrzId) {
        setCurrentStep(8);
      }
      if (currentStep === 8 && isNotesModalOpen) {
        setCurrentStep(9);
      }
    }
  }, [isOpen, currentStep, selectedMrzId, isNotesModalOpen, setCurrentStep]);

  if (!isResultLoading && !isImageLoading && (!resultData || !imageData)) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <AnalysisPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)}>
        <BugReportForm onClose={() => setIsPopupOpen(false)} />
      </AnalysisPopup>
      <AnalysisPopup
        isOpen={isNotesModalOpen}
        onClose={() => setIsNotesModalOpen(false)}
      >
        <NotesModal
          onClose={() => setIsNotesModalOpen(false)}
          notesData={sidebarProps.notesData}
          resultData={resultData}
        />
      </AnalysisPopup>
      <div className="flex w-full flex-col overflow-x-hidden lg:flex-row">
        <Sidebar {...sidebarProps} />
        <CanvasContainer>
          <div className="relative flex h-full w-full">
            <Canvas
              {...canvasProps}
              setIsNotesModalOpen={setIsNotesModalOpen}
            />
          </div>
        </CanvasContainer>
      </div>
    </>
  );
};
